const formStyle = {
  cardActionStyle: {
    zIndex: 2,
    display: "inline-block",
    float: "right",

    iconStyle: {
      justifyContent: "flex-end",
      alignItems: "flex-end",
      marginBottom: "-25%"
    }
  },
  titleContainer: {
    marginBottom: "2%"
  },
  titleStyle: {
    textTransform: "capitalize",
    fontWeight: "bold"
  }
};

export default formStyle;



// WEBPACK FOOTER //
// ./src/containers/CRM/Regions/style.js